import { Component } from '@angular/core';
import { CompanyCardDirective } from '../company-card.directive';
import { ProfileService } from '../../../dashboard';

@Component({
  selector: 'app-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
})
export class ContactCardComponent extends CompanyCardDirective<string> {
  constructor(public profileService: ProfileService) {
    super();
  }
}
